export const SET_BOOKING_DATA = 'app/set_booking_data'
export const GET_MONTH_SLOTS = 'app/get_month_slots'
export const GET_SESSIONS = 'app/get_sessions'
export const BOOK_PRELIMINARILY = 'app/book_preliminarily'
export const BOOK_BY_ADMIN = 'app/book_by_admin'
export const CREATE_PATIENT = 'app/create_patient'
export const GET_PATIENT = 'app/get_patient'
export const INITIATE_PAYMENT = 'app/initiate-payment'
